export * from './shopDetailQuery';
export type { ShopDetailResponse as ShopDetail } from './types';
